import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import makeStyles from '@mui/styles/makeStyles';
import TextField from '@mui/material/TextField';
import StyledButton from '../../components/button/StyledButton.jsx';
import { setTabIndex } from '../../helpers/accessibility_helper';

const useStyles = makeStyles(() => ({
  btn: {
    width: '100%',
    padding: '24px 0px',
    height: 36,
  },
  showTextComment: {
    width: '100%',
  },
}));

const Footer = ({
  value,
  onConfirm,
  shouldFocusOnComment = false,
  optionalComment = null,
  onChangeComment = null,
  skipAsContinue = false,
  showOkButton = false,
  showSkipButton = true,
  showTextComment = false,
  commentAriaLabel,
  isActive = true,
  label = 'Comments',
  placeholder = 'Write your comment here...',
  translation,
}) => {
  const styles = useStyles();
  const textareaRef = useRef();

  useEffect(() => {
    let hasValue;

    if (Array.isArray(value)) {
      hasValue = value.length !== 0;
    } else if (typeof value === 'number') {
      hasValue = true;
    } else {
      hasValue = Boolean(value);
    }

    if (hasValue && shouldFocusOnComment && showTextComment && !optionalComment) {
      textareaRef.current.focus();
    }
  }, [value, shouldFocusOnComment, showTextComment, optionalComment]);

  return (
    <>
      {showSkipButton && (
        <div className={styles.btn}>
          <StyledButton
            onClick={() => onConfirm(false)}
            ariaLabel={skipAsContinue ? translation.arialContinue : translation.arialSkip}
            tabIndex={setTabIndex(isActive)}
          >
            {skipAsContinue ? translation.continueButton : translation.skipButton}
          </StyledButton>
        </div>
      )}

      {showTextComment && (
        <div className={styles.showTextComment}>
          <TextField
            label={label}
            placeholder={placeholder}
            id="outlined-multiline-comments"
            multiline
            rows="4"
            value={optionalComment}
            onChange={onChangeComment}
            margin="normal"
            variant="outlined"
            fullWidth
            inputRef={textareaRef}
            inputProps={{
              'aria-label': commentAriaLabel,
              tabIndex: setTabIndex(isActive),
              'aria-hidden': !isActive,
            }}
          />
        </div>
      )}

      {showOkButton && (
        <div className={styles.btn}>
          <StyledButton
            onClick={() => onConfirm(true)}
            ariaLabel={translation.arialOk}
            tabIndex={setTabIndex(isActive)}
          >
            {translation.okButton}
          </StyledButton>
        </div>
      )}
    </>
  );
};

Footer.propTypes = {
  shouldFocusOnComment: PropTypes.bool,
  onConfirm: PropTypes.func,
  optionalComment: PropTypes.string,
  onChangeComment: PropTypes.func,
  skipAsContinue: PropTypes.bool,
  showOkButton: PropTypes.bool,
  showSkipButton: PropTypes.bool,
  showTextComment: PropTypes.bool,
  isActive: PropTypes.bool,
};

export default Footer;
